var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":_vm.wpLink}},[(!_vm.arabic)?_c('img',{staticClass:"h-10",attrs:{"src":require("../../assets/images/LogoDark.svg"),"alt":"Ayadi"}}):_c('img',{staticClass:"h-10",attrs:{"src":require("../../assets/images/LogoDarkArabic.svg"),"alt":"Ayadi"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }